import React from "react";
import WhiteLogo from "../../assets/images/white-logo.png";
import { MdOutlineEmail } from "react-icons/md";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareFacebook, FaXTwitter, FaYoutube } from "react-icons/fa6";

const MainFooter = () => {
  return (
    <>
      <footer className="bg-[linear-gradient(90deg,#2A2A2A_0%,#111827_100%)]">
        <div className="container mx-auto px-6 md:px-12 py-6">
          <div className="flex justify-between gap-x-12 gap-y-4 md:gap-x-4 flex-wrap">
            <div className="w-full lg:w-[25%]">
              <img src={WhiteLogo} alt="white logo" />
              <p className="text-white text-[14px] pt-3">
                Dive into local recommendations for a truly authentic
                experience.
              </p>

              <ul className="pt-3 flex flex-col gap-2 text-white text-[13px] font-normal">
                {/* <li className="flex items-start gap-1 text-white text-[13px] font-normal">
                  <svg
                    width="16"
                    height="23"
                    viewBox="0 0 16 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00016 5C4.805 5 2.20557 7.59944 2.20557 10.7946C2.20557 14.7598 7.39116 20.581 7.61194 20.8269C7.81932 21.0579 8.18138 21.0575 8.38838 20.8269C8.60916 20.581 13.7948 14.7598 13.7948 10.7946C13.7947 7.59944 11.1953 5 8.00016 5ZM8.00016 13.71C6.3926 13.71 5.08478 12.4021 5.08478 10.7946C5.08478 9.187 6.39263 7.87919 8.00016 7.87919C9.60769 7.87919 10.9155 9.18703 10.9155 10.7946C10.9155 12.4022 9.60769 13.71 8.00016 13.71Z"
                      fill="white"
                    />
                  </svg>
                  1237 Washington Ave. Manchester, Kentucky 12495
                </li> */}
                {/* <li className="flex items-start gap-1 text-white text-[13px] font-normal">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.33334 0C5.88294 0 4.46512 0.430096 3.25916 1.23589C2.0532 2.04169 1.11327 3.187 0.558216 4.52699C0.00317729 5.86698 -0.142047 7.34147 0.140911 8.764C0.423866 10.1865 1.12231 11.4932 2.14789 12.5188C3.17348 13.5444 4.48015 14.2428 5.90268 14.5258C7.32521 14.8087 8.7997 14.6635 10.1397 14.1085C11.4797 13.5534 12.625 12.6135 13.4308 11.4075C14.2366 10.2016 14.6667 8.78373 14.6667 7.33334C14.6644 5.38912 13.891 3.52519 12.5163 2.15042C11.1415 0.775646 9.27756 0.002294 7.33334 0ZM9.8047 9.8047C9.6797 9.9297 9.5101 9.9999 9.33334 9.9999C9.15656 9.9999 8.98703 9.9297 8.86201 9.8047L6.86201 7.80467C6.73697 7.67968 6.66671 7.51013 6.66667 7.33334V3.33334C6.66667 3.15653 6.73691 2.98696 6.86194 2.86193C6.98696 2.73691 7.15653 2.66667 7.33334 2.66667C7.51015 2.66667 7.67972 2.73691 7.80474 2.86193C7.92977 2.98696 8.00001 3.15653 8.00001 3.33334V7.05734L9.8047 8.862C9.9297 8.98702 9.9999 9.15656 9.9999 9.33334C9.9999 9.5101 9.9297 9.6797 9.8047 9.8047Z"
                      fill="white"
                    />
                  </svg>
                  Hours: 8:00 - 17:00, Mon - Sat
                </li> */}
                <li className="flex items-start gap-1 text-white text-[13px] font-normal">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.96372 3.07378L6.28622 7.39816C7.22897 8.33909 8.77003 8.33991 9.71356 7.39816L14.0361 3.07378C14.0796 3.03025 14.0732 2.95856 14.0227 2.92334C13.5819 2.61588 13.0455 2.43359 12.4677 2.43359H3.53216C2.95431 2.43359 2.41791 2.61591 1.97703 2.92334C1.92653 2.95856 1.92019 3.03025 1.96372 3.07378ZM0.808594 5.15713C0.808594 4.70275 0.92125 4.27344 1.11969 3.89609C1.15072 3.83706 1.22938 3.82513 1.27653 3.87228L5.54431 8.14006C6.89578 9.4935 9.10322 9.49428 10.4555 8.14006L14.7233 3.87228C14.7704 3.82513 14.8491 3.83706 14.8801 3.89609C15.0785 4.27344 15.1912 4.70278 15.1912 5.15713V10.8427C15.1912 12.3456 13.9687 13.5662 12.4677 13.5662H3.53216C2.03116 13.5662 0.808594 12.3456 0.808594 10.8427V5.15713Z"
                      fill="white"
                    />
                  </svg>
                  support@Toucan.com
                </li>
              </ul>
            </div>
            <div className="pt-4">
              <p className="text-white font-semibold  text-[14px]">
                Navigation
              </p>
              <ul className="pt-3 flex flex-col gap-2 text-white text-[13px] font-normal">
                <li>Home</li>
                <li>Top Experiences</li>
                <li>Vendors</li>
                <li>Testimonials</li>
              </ul>
            </div>
            <div className="pt-4">
              <p className="text-white font-semibold  text-[14px]">Legal</p>
              <ul className="pt-3 flex flex-col gap-2 text-white text-[13px] font-normal">
                <li>Privacy Policy</li>
                <li>Terms of Service</li>
                <li>FAQs</li>
                <li>Teams</li>
              </ul>
            </div>
            <div className="pt-4 w-full md:w-fit">
              <div className="block md:hidden w-full mx-auto justify-center flex items-center gap-2">
                <p className="text-white font-semibold text-md">Follow us</p>
                <ul className="flex flex-wrap gap-2">
                  <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                    <AiFillInstagram className="text-white" />
                  </li>
                  <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                    <FaSquareFacebook className="text-white" />
                  </li>
                  <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                    <FaXTwitter className="text-white" />
                  </li>
                  <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                    <FaYoutube className="text-white" />
                  </li>
                </ul>
              </div>
              <p className="hidden md:block text-white font-semibold  text-[14px]">
                Newsletter
              </p>

              <div className="pt-6 md:pt-0 lg:pt-4 flex justify-center flex-col items-center border-t md:border-t-0 border-t-gray-600 mt-6">
                <form className="flex flex-col gap-2">
                  <div className="relative">
                    <MdOutlineEmail className="absolute z-[99] text-white top-4 left-4" />
                    <input
                      className="border border-[#D9D9D9] w-full rounded-lg bg-black py-3 pl-10 pr-2 text-white"
                      type="email"
                      placeholder="Enter your email"
                    />
                  </div>
                  <button className="py-3 px-12 bg-[#16BBD8] text-white w-full rounded-lg">
                    Subscribe
                  </button>
                </form>
                <div className="hidden md:block">
                  <div className=" pt-6 flex items-center gap-2">
                    <p className="text-white font-semibold text-md">
                      Follow us
                    </p>
                    <ul className="flex flex-wrap gap-2">
                      <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                        <AiFillInstagram className="text-white" />
                      </li>
                      <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                        <FaSquareFacebook className="text-white" />
                      </li>
                      <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                        <FaXTwitter className="text-white" />
                      </li>
                      <li className="w-8 h-8 flex justify-center cursor-pointer items-center rounded-full bg-black border border-[#575756]">
                        <FaYoutube className="text-white" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-white text-[11px] pt-12 md:pt-4">
            © 2025 Toucan Inc. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default MainFooter;
